import { z } from 'zod';
import { dateLike } from '@/schemas/field-schemas';

export const searchSchema = z.object({
  // Main fields
  ngay_ct1: dateLike,
  ngay_ct2: dateLike,

  // FormField only (non-SearchField)
  trackInventory: z.boolean().optional(),
  balance: z.string().optional(),
  details_collection: z.string().optional(),
  reportTemplate: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  description: z.string().optional(),
  reportFilterTemplate: z.string().optional()
});

export const initialValues = {
  // Main fields
  ngay_ct1: '', // Today's date in YYYY-MM-DD format
  ngay_ct2: '', // Today's date in YYYY-MM-DD format

  // FormField only (non-SearchField)
  trackInventory: false,
  balance: '0',
  details_collection: '1',
  reportTemplate: 'TC',
  so_ct1: '',
  so_ct2: '',
  description: '',
  reportFilterTemplate: 'user_filter'
};
